export default __webpack_public_path__ + "static/media/f_wdt_c_4.f6894819.mp3";